module.exports = __webpack_public_path__ + "img/36.e203b251.jpg";